import { Navigate, Outlet } from 'react-router-dom';
import { useMe } from '@/lib/me';

/**
 * Platform admin console. Hiding it from non-admins is a convenience only:
 * every /v1/admin route checks the admin flag on the server.
 */
export function AdminLayout() {
  const me = useMe();
  if (me.isPending) return <p className="text-sm text-muted-foreground">Loading…</p>;
  if (!me.data?.isPlatformAdmin) return <Navigate to="/home" replace />;
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold">Platform admin</h1>
      </div>
      <Outlet />
    </div>
  );
}
